import React from 'react'
import styles from './three-column.module.css'

export default ({ children }) => (
  <div className={styles.threeColumn}>
    {children}
  </div>
)
